<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 14:31:23
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-17 11:27:22
 * @FilePath: /knit-web/src/components/settings-modal/components/members.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="members-content">
    <div class="content-header">
      <h2>{{ t('workspaceSettings.members.title') }}</h2>
    </div>

    <div class="members-section">
      <!-- 工作空间信息卡片 -->
      <div class="workspace-card">
        <div class="workspace-card-header">
          <a-avatar :size="40" style="background-color: #165dff; color: #fff">
            {{ currentWorkspace?.name?.slice(0, 1) }}
          </a-avatar>
          <div class="workspace-info">
            <div class="workspace-name-row">
              <h3>{{ currentWorkspace?.name || 'Default Workspace' }}</h3>
              <a-button
                v-if="isWorkspaceOwner"
                type="outline"
                size="small"
                @click="showEditWorkspaceModal = true"
              >
                {{ t('workspaceSettings.members.edit') }}
              </a-button>
            </div>
            <div class="workspace-meta">
              <!-- <span
                >{{ t('workspaceSettings.members.memberCount') }}:
                {{ list.length }} / 5</span
              > -->
              <a-tag v-if="isWorkspaceOwner" color="blue">{{
                t('workspaceSettings.members.owner')
              }}</a-tag>
            </div>
          </div>
          <a-button
            v-if="isWorkspaceOwner && !isDefaultWorkspace"
            type="primary"
            @click="showInviteModal = true"
          >
            <template #icon>
              <icon-user-add />
            </template>
            {{ t('workspaceSettings.members.add') }}
          </a-button>
          <!-- <a-button
            type="primary"
            status="danger"
            @click="showLeaveWorkspaceModal = true"
          >
            <template #icon>
              <icon-export />
            </template>
            {{ t('workspaceSettings.members.leaveWorkspace') }}
          </a-button> -->
        </div>
      </div>

      <!-- 成员列表 -->
      <a-table
        :data="list"
        :loading="loading"
        :bordered="false"
        :pagination="false"
        row-key="user_uuid"
        class="members-table"
      >
        <template #columns>
          <a-table-column
            :title="t('workspaceSettings.members.member')"
            :width="400"
          >
            <template #cell="{ record }">
              <div class="member-info">
                <a-avatar
                  :size="32"
                  style="background-color: #165dff; color: #fff"
                >
                  {{
                    (record.user?.email || record.email || 'U')
                      .slice(0, 1)
                      .toUpperCase()
                  }}
                </a-avatar>
                <div class="member-details">
                  <div class="member-name">
                    {{
                      record.user?.nickname ||
                      record.user?.email ||
                      record.nickname ||
                      record.email ||
                      'Name'
                    }}
                  </div>
                  <div class="member-email">
                    {{ record.user?.email || record.email || 'Email' }}
                  </div>
                </div>
                <a-tag
                  v-if="record.user_uuid === userStore.user_uuid"
                  color="blue"
                  size="small"
                >
                  {{ t('workspaceSettings.members.me') }}
                </a-tag>
                <a-tag v-else-if="record.type === 1" color="blue" size="small">
                  {{ t('workspaceSettings.members.owner') }}
                </a-tag>
                <a-tag v-else color="green" size="small">
                  {{ t('workspaceSettings.members.member') }}
                </a-tag>
              </div>
            </template>
          </a-table-column>
          <a-table-column
            :title="t('workspaceSettings.members.joinedAt')"
            :width="180"
          >
            <template #cell="{ record }">
              {{ formatDate(record.created_at) }}
            </template>
          </a-table-column>
          <a-table-column
            :title="t('workspaceSettings.members.actions')"
            :width="100"
            align="center"
          >
            <template #cell="{ record }">
              <a-button
                v-if="
                  isWorkspaceOwner || record.user_uuid === userStore.user_uuid
                "
                type="text"
                status="danger"
                @click="handleRemoveMember(record)"
              >
                <icon-export />
              </a-button>
            </template>
          </a-table-column>
        </template>
      </a-table>
    </div>

    <!-- 邀请成员弹窗 -->
    <InviteMemberModal
      v-model="showInviteModal"
      @invite="handleInvite"
      @success="handleInviteSuccess"
    />

    <!-- 邀请成功确认弹窗 -->
    <InviteSuccessModal
      v-model="showInviteSuccessModal"
      @back="handleBackToSettings"
      @invite-another="handleInviteAnother"
    />

    <!-- 移除成员确认弹窗 -->
    <RemoveMemberModal
      v-model="showRemoveModal"
      :loading="removeLoading"
      @confirm="handleConfirmRemove"
    />

    <!-- 离开工作空间确认弹窗 -->
    <LeaveWorkspaceModal
      v-model="showLeaveWorkspaceModal"
      :loading="leaveWorkspaceLoading"
      @confirm="handleConfirmLeaveWorkspace"
    />

    <!-- 编辑工作空间弹窗 -->
    <EditWorkspaceModal
      v-model="showEditWorkspaceModal"
      :workspace="currentWorkspace"
      @success="handleWorkspaceUpdateSuccess"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import Message from '@/utils/message';
  import { useUserStore } from '@/store';
  import {
    IconUserAdd,
    IconMore,
    IconDelete,
  } from '@arco-design/web-vue/es/icon';
  import {
    listWorkspaceMembersApi,
    inviteWorkspaceMemberApi,
    removeWorkspaceMemberApi,
    leaveWorkspaceApi,
  } from '@/api/workspace';
  import useList from '@/hooks/useList';
  import InviteMemberModal from './invite-member-modal.vue';
  import InviteSuccessModal from './invite-success-modal.vue';
  import RemoveMemberModal from './remove-member-modal.vue';
  import LeaveWorkspaceModal from './leave-workspace-modal.vue';
  import EditWorkspaceModal from './edit-workspace-modal.vue';

  const { t, locale } = useI18n();
  const userStore = useUserStore();

  const showInviteModal = ref(false);
  const showInviteSuccessModal = ref(false);
  const showLeaveWorkspaceModal = ref(false);
  const showRemoveModal = ref(false);
  const showEditWorkspaceModal = ref(false);
  const removeLoading = ref(false);
  const memberToRemove = ref<any>(null);
  const leaveWorkspaceLoading = ref(false);
  const currentWorkspace = computed(() =>
    userStore.workspaceList?.find(
      (w) => w.workspace_uuid === userStore.workspaceUuid
    )
  );

  const isWorkspaceOwner = computed(() => {
    return currentWorkspace.value?.workspace_member?.type === 1;
  });

  const isDefaultWorkspace = computed(() => {
    return currentWorkspace.value?.type === 1;
  });

  // 使用 useList hook
  const filterOption = ref({
    filters: {
      tenant_uuid: userStore.tenantUuid!,
      workspace_uuid: userStore.workspaceUuid!,
    },
  });

  const { list, loading, loadData } = useList(
    listWorkspaceMembersApi,
    filterOption,
    {
      pagination: false,
      immediate: false,
      message: {
        GET_DATA_IF_FAILED:
          t('workspaceSettings.members.loadFailed') || '加载成员列表失败',
      },
    }
  );

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '—';
    try {
      const date = new Date(dateStr);
      const localeStr = locale.value === 'zh-CN' ? 'zh-CN' : 'en-US';
      return date.toLocaleString(localeStr, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateStr;
    }
  };

  const handleInvite = async (user: any) => {
    await inviteWorkspaceMemberApi({
      inviter_tenant_uuid: userStore.tenantUuid!,
      inviter_workspace_uuid: userStore.workspaceUuid!,
      invitee_email: user.email!,
    });
  };

  const handleInviteSuccess = () => {
    showInviteSuccessModal.value = true;
    loadData();
  };

  const handleBackToSettings = () => {
    // 关闭所有弹窗
  };

  const handleInviteAnother = () => {
    showInviteModal.value = true;
  };

  const handleRemoveMember = (member: any) => {
    if (member.user_uuid === userStore.user_uuid) {
      showLeaveWorkspaceModal.value = true;
      return;
    }
    memberToRemove.value = member;
    showRemoveModal.value = true;
  };

  const handleConfirmRemove = async () => {
    if (!memberToRemove.value) return;

    try {
      removeLoading.value = true;
      await removeWorkspaceMemberApi({
        workspace_uuid: userStore.workspaceUuid!,
        user_uuid: memberToRemove.value.user_uuid,
      });

      Message.success(
        t('workspaceSettings.members.removeSuccess') || '移除成功'
      );
      showRemoveModal.value = false;
      memberToRemove.value = null;
      loadData();
    } catch (err: any) {
      Message.error(
        err?.response?.data?.msg ||
          t('workspaceSettings.members.removeFailed') ||
          '移除失败'
      );
    } finally {
      removeLoading.value = false;
    }
  };

  const handleConfirmLeaveWorkspace = async () => {
    try {
      leaveWorkspaceLoading.value = true;
      await leaveWorkspaceApi({
        workspace_uuid: userStore.workspaceUuid!,
        tenant_uuid: userStore.tenantUuid!,
      });
      Message.success(t('workspaceSettings.members.leaveWorkspaceSuccess'));
      showLeaveWorkspaceModal.value = false;
      window.location.reload();
    } finally {
      leaveWorkspaceLoading.value = false;
    }
  };

  const handleWorkspaceUpdateSuccess = async () => {
    // 刷新工作空间列表
    await userStore.fetchUserWorkspaceList();
    // 刷新成员列表
    loadData();
  };

  onMounted(() => {
    loadData();
  });
</script>

<style lang="less" scoped>
  .members-content {
    .content-header {
      margin-bottom: 24px;

      h2 {
        font-size: 24px;
        font-weight: 600;
        color: var(--color-text-1);
        margin: 0 0 8px 0;
      }
    }

    .members-section {
      .workspace-card {
        background: #fff;
        border: 1px solid var(--color-border-2);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 24px;

        .workspace-card-header {
          display: flex;
          align-items: center;
          gap: 16px;

          .workspace-info {
            flex: 1;

            .workspace-name-row {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-bottom: 8px;

              h3 {
                font-size: 18px;
                font-weight: 600;
                color: var(--color-text-1);
                margin: 0;
              }
            }

            .workspace-meta {
              display: flex;
              align-items: center;
              gap: 12px;
              font-size: 14px;
              color: var(--color-text-3);
            }
          }
        }
      }

      .members-table {
        background: #fff;
        border: 1px solid var(--color-border-2);
        border-radius: 12px;
        overflow: hidden;

        :deep(.arco-table-container) {
          border-radius: 12px;
        }

        .member-info {
          display: flex;
          align-items: center;
          gap: 12px;

          .member-details {
            flex: 1;

            .member-name {
              font-size: 14px;
              font-weight: 500;
              color: var(--color-text-1);
              margin-bottom: 4px;
            }

            .member-email {
              font-size: 13px;
              color: var(--color-text-3);
            }
          }
        }
      }
    }
  }

  .user-search-result {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid var(--color-border-2);
    width: 100%;

    &.error {
      background: var(--color-danger-light-1);
      border-color: var(--color-danger-light-3);
      color: var(--color-danger-6);

      .arco-icon {
        color: var(--color-danger-6);
      }
    }

    &.selected {
      background: var(--color-bg-2);
      border-color: var(--color-primary-light-3);

      .user-info {
        flex: 1;

        .user-name {
          font-size: 14px;
          font-weight: 500;
          color: var(--color-text-1);
          margin-bottom: 4px;
        }

        .user-email {
          font-size: 13px;
          color: var(--color-text-3);
        }
      }
    }
  }

  .invite-success-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
  }

  .invite-success-content {
    padding: 20px 0;
    text-align: center;

    p {
      margin: 0;
      font-size: 14px;
      color: var(--color-text-2);
      line-height: 1.6;
    }
  }

  .invite-success-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
  }

  .remove-member-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
  }

  .remove-member-content {
    padding: 20px 0;

    p {
      margin: 0;
      font-size: 14px;
      color: var(--color-text-2);
      line-height: 1.6;
    }
  }
</style>
